import { render } from "./ModifyExistingEcrfTree.vue?vue&type=template&id=1c07c39a&scoped=true"
import script from "./ModifyExistingEcrfTree.vue?vue&type=script&lang=js"
export * from "./ModifyExistingEcrfTree.vue?vue&type=script&lang=js"

import "./ModifyExistingEcrfTree.vue?vue&type=style&index=0&id=1c07c39a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c07c39a"]])

export default __exports__